import { render, staticRenderFns } from "./LsvaTruckDetailsView.vue?vue&type=template&id=24124438&scoped=true&"
import script from "./LsvaTruckDetailsView.vue?vue&type=script&lang=js&"
export * from "./LsvaTruckDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./LsvaTruckDetailsView.vue?vue&type=style&index=0&id=24124438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24124438",
  null
  
)

/* custom blocks */
import block0 from "./LsvaTruckDetailsView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports